export type EnvConfig = {
  __vars__: Record<string, string | undefined>;
  env: 'development' | 'test' | 'staging' | 'production';
  services: {
    apiUrl: string;
    integrationApiUrl?: string;
    wssUrl?: string;

    wlUrl?: string;

    /*
      TODO 
      1. works because it is site-one, and only accesses the 'data-cms'
      2. ...it's an env var, but basically always uses the fallback
      3. for our marketing sites / 'content-cms', this will be confusing to understand the difference
      4. marketing sites / 'content-cms' will have a unique token for each brand, which would have to be added to the sites-config.types.ts it's services.cms.<data|content>.<preview|production> config
    */
    cms: {
      accessToken: {
        production: string;
        preview: string;
      };
    };
  };
};

/**
 * mapping in `env-to-store`
 *
 */

// schema & defaults
export const envSchema = {
  MODE: 'development',
  NEXT_PUBLIC_ENV: 'development',

  VITE_APP_API_URL: 'https://api.axo-test.io',
  NEXT_PUBLIC_API_URL: 'https://api.axo-test.io',

  VITE_APP_INTEGRATION_URL: 'https://integration.axo-test.io',
  NEXT_PUBLIC_INTEGRATION_API_URL: 'https://integration.axo-test.io',

  VITE_APP_WS_URL: 'wss://ws.axo.ninja',
  NEXT_PUBLIC_WSS_URL: 'wss://ws.axo.ninja',

  NEXT_PUBLIC_WL_URL: 'https://form.axo-test.io',

  NEXT_PUBLIC_CMS_PREVIEW:
    'ac_0e165442b28be0095ff2a3374481fd5bff5af5919891b15285c842a3617fcf6c',
  NEXT_PUBLIC_CMS_PRODUCTION:
    'ac_ad7d6b8f070984cc953550b5d430aef72e19c6225406c0fbf091be384b46529e',
} as const;

export type EnvFile = Partial<Record<keyof typeof envSchema, string>>;
